// extracted by mini-css-extract-plugin
export default {"about":"About_about__BPr+o","title":"About_title__xoekP","subText":"About_subText__GKkyP","Text":"About_Text__M9ZFw"};